import React from 'react'

class ScrollContainer extends React.Component {
    render() {
        const {children, style = {}} = this.props

        const defaultStyle = {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            background: 'transparent',
            flex: 1,
            minHeight: 0,
            overflowY: 'auto',
            width: '100%',
            ...style
        }

        return (
            <div style={defaultStyle}>
                {children}
            </div>

        )
    }
}

export default ScrollContainer
